module.exports = __webpack_public_path__ + "static/media/park-solution-box1.0fb44ca4.png";